/* keep these style imports at the top as moving below the Navigation import breaks specificity for random styles (we're slowly refactoring to css modules) */
import '@/assets/Styles/common.scss';
import '@/assets/Styles/Maverick.scss';
import '@/assets/Styles/main.scss';
import '@/assets/Styles/Maverick-responsive.scss';
import './Assets/Styles/kendo-icons.css';

import React from 'react';
import { IconsContext } from '@progress/kendo-react-common';
import { useClearCache } from 'react-clear-cache';

import Navigation from './navigation/navigation';
import { ThemeProvider } from './theme/Theme';
import ErrorBoundary from './pages/unAuthorized/ErrorBoundary';

const App: React.FC<{}> = () => {
  const { isLatestVersion, emptyCacheStorage, latestVersion } = useClearCache();

  React.useEffect(() => {
    if (!isLatestVersion) {
      emptyCacheStorage();
    }
  }, [ isLatestVersion, latestVersion, emptyCacheStorage ]);

  return (
    <ErrorBoundary>
      <IconsContext.Provider value={{ type: 'svg' }}>
        <ThemeProvider>
          <Navigation/>
        </ThemeProvider>
      </IconsContext.Provider>
    </ErrorBoundary>
  );
};
export default App;
